"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertiesStatsWrapper$ = exports.PropertiesStatsWrapper$outboundSchema = exports.PropertiesStatsWrapper$inboundSchema = void 0;
exports.propertiesStatsWrapperToJSON = propertiesStatsWrapperToJSON;
exports.propertiesStatsWrapperFromJSON = propertiesStatsWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const propertiesstatsattributes_js_1 = require("./propertiesstatsattributes.js");
/** @internal */
exports.PropertiesStatsWrapper$inboundSchema = z.object({
    attributes: propertiesstatsattributes_js_1.PropertiesStatsAttributes$inboundSchema,
    id: z.string(),
    type: z.literal("property").default("property").optional(),
});
/** @internal */
exports.PropertiesStatsWrapper$outboundSchema = z.object({
    attributes: propertiesstatsattributes_js_1.PropertiesStatsAttributes$outboundSchema,
    id: z.string(),
    type: z.literal("property").default("property"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertiesStatsWrapper$;
(function (PropertiesStatsWrapper$) {
    /** @deprecated use `PropertiesStatsWrapper$inboundSchema` instead. */
    PropertiesStatsWrapper$.inboundSchema = exports.PropertiesStatsWrapper$inboundSchema;
    /** @deprecated use `PropertiesStatsWrapper$outboundSchema` instead. */
    PropertiesStatsWrapper$.outboundSchema = exports.PropertiesStatsWrapper$outboundSchema;
})(PropertiesStatsWrapper$ || (exports.PropertiesStatsWrapper$ = PropertiesStatsWrapper$ = {}));
function propertiesStatsWrapperToJSON(propertiesStatsWrapper) {
    return JSON.stringify(exports.PropertiesStatsWrapper$outboundSchema.parse(propertiesStatsWrapper));
}
function propertiesStatsWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertiesStatsWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertiesStatsWrapper' from JSON`);
}
//# sourceMappingURL=propertiesstatswrapper.js.map